import { ReactComponent as ArrowLeftCircle } from 'assets/svg/arrow-left-circle.svg';
import { ReactComponent as ArrowRightCircle } from 'assets/svg/arrow-right-circle.svg';
import React from 'react';

interface ISuggestionsSliderScrollbarProps {
    elementSuffix: number;
}

const SuggestionsSliderScrollbar = ({ elementSuffix }: ISuggestionsSliderScrollbarProps) => {
    return (
        <div className="taffi-style-swiper-toolbar">
            <div
                id={`taffi-swiper-button-prev-${elementSuffix}`}
                className="taffi-swiper-button-prev"
                role="button"
                aria-label="Previous slide"
                aria-controls="swiper-wrapper-8f5882676c81ac75"
            >
                <div className="taffi-nav-button">
                    <ArrowLeftCircle className={'taffi-nav-svg'} width={12} height={12} />
                </div>
            </div>
            <div
                id={`taffi-swiper-button-next-${elementSuffix}`}
                className="taffi-swiper-button-next"
                role="button"
                aria-label="Next slide"
                aria-controls="swiper-wrapper-8f5882676c81ac75"
            >
                <div className="taffi-nav-button">
                    <ArrowRightCircle className={'taffi-nav-svg'} width={12} height={12} />
                </div>
            </div>
        </div>
    );
};

export default SuggestionsSliderScrollbar;
